﻿import { UserSelect } from "@/containers/Project/components";
import { projectMilestoneType } from "@/propTypes";
import { Form } from "antd";
import { arrayOf, bool, object } from "prop-types";
import { useIntl } from "react-intl";

const AssignedUserSelector = ({ disabled, projectLeaders, role }) => {
  const intl = useIntl();

  return (
    <Form.Item
      label={intl.formatMessage({ id: "project.approvers.user" })}
      initialValue={!disabled ? projectLeaders[role.regionId] : ""}
      name={[role.id, "assignedUser"]}
    >
      <UserSelect
        users={disabled ? [] : [projectLeaders[role.regionId]]}
        disabled={disabled}
        readOnly
        multipleSelect={false}
      />
    </Form.Item>
  );
};

AssignedUserSelector.propTypes = {
  disabled: bool,
  projectLeaders: arrayOf(object).isRequired,
  role: projectMilestoneType.isRequired,
};

export default AssignedUserSelector;
